export default {
  action: {
    cancelled: 'Cancelled',
    completed: 'Completed',
    new: 'New',
    sent: 'Sent',
    unfinishedForm: 'Unfinished form'
  },
  activationAccount: {
    activeAccountButton: 'Activate your account',
    confirmationActivation: 'Confirmation of account activation',
    thankYouForActivation: 'Thank you for confirming your registration. You will receive an email after approval from the Administrator. Then you can start using the expert panel.'
  },
  adviserSettings: {
    contactData: 'Contact information',
    education: 'Education',
    invoiceData: 'Invoice details',
    logoAndColors: 'Color scheme and logo',
    myExpertCard: 'My expert card',
    photoExpert: 'Expert profile photo ',
    workExperience: 'Work experience',
    yourDataHasBeenSaved: 'Your data has been saved',
    yourDataModifyError: 'Modification of your data failed. Please try again.'
  },
  adviserSettingsBusinessCardInfo: {
    cut: 'Cut',
    dateStartWork: 'Start date',
    deletePhoto: 'Delete photo',
    description: 'Description',
    infoAboutYourCustomerCardHasBeenSaved: 'Your client business card information has been saved',
    itsNotAPhoto: 'The selected file is not an image file',
    littleDescription: 'Brief description',
    photo: 'Photo',
    preview: 'Preview',
    reset: 'Reset',
    thisTextWillBeVisibleOnYourCard: 'This text will be visible in It’s business card, in the "About Me" section.',
    thisTextWillBeVisibleUnderYourSurname: 'This text will be visible in the list of experts, under your name.',
    yourDataWillBePublic: 'The information provided in this section will be available to the public.'
  },
  adviserSettingsEducationInfo: {
    addEntry: 'Add entry',
    areYouSureRemove: 'Are you sure you want to delete this entry?',
    editEntry: 'Edit entry',
    entryHasBeenRemove: 'The selected entry has been deleted',
    entryModifyError: 'Entry modification failed. Try again.',
    entryRemove: 'Entry removed',
    entryRemoveError: 'Deleting the entry failed. Try again.',
    fieldOfStudy: 'Field of study',
    newEntry: 'New entry',
    savedEntry: 'The entry has been saved',
    selectedEntryHasBeenSaved: 'The selected entry has been saved',
    timeEnd: 'Completion date',
    timeStart: 'Start date',
    university: 'University'
  },
  adviserSettingsEmailInfo: {
    currentColor: 'Current color',
    generalColor: 'Main color',
    logo: 'Logo',
    selectNewColor: 'Choose a new color',
    sendTestMailMessage: 'The test email has been sent',
    sendTestMailMessageError: 'Sending a test email failed. Please try again.'
  },
  adviserSettingsExperienceInfo: {
    employer: 'Employer',
    position: 'Position'
  },
  adviserSettingsInvoiceInfo: {
    yourDataForInvoicesHasBeenSaved: 'Your invoice details have been saved'
  },
  advisersFinder: {
    collapseFilters: 'Collapse filters',
    errorLocation: 'Your location could not be downloaded. Check your browser/device settings and try again.',
    expandFilters: 'Expand filters',
    findFinanceExpert: 'Find a financial expert to advise you on the best loan offer.',
    fromTheHighestRated: 'From the highest rated',
    fromTheMostFrequentlyRated: 'From the most frequently rated',
    inDistanceFromMe: 'At a distance from me',
    noItemForShow: 'No items to display',
    onSurName: 'By surname',
    resetFilters: 'Reset filters',
    showOnlyOnlineExperts: 'Show only online experts',
    sort: 'Sort',
    theFinanceExpert: 'Financial experts'
  },
  app: {
    designDevelopment: 'Design and development',
    restartSessionError: 'There was an error while renewing your session. Please refresh the page.'
  },
  articleForm: {
    adminComment: 'Admin comment',
    article: 'Article',
    articles: 'Articles',
    articleSaveAndSend: 'Your article has been saved and sent for approval',
    backToArticleList: 'Return to article list',
    saveArticle: 'The article has been saved',
    saveArticleError: 'The article write-up failed. Try again.'
  },
  articleList: {
    createArticle: 'Create an article',
    deleteArticle: 'Deleted article',
    deleteArticleError: 'Deleting the article failed. Try again.',
    deleteSelectArticle: 'The selected article has been removed',
    doYouWantDeleteArticle: 'Are you sure you want to delete this article?',
    linkToArticle: 'Link to article',
    published: 'Published'
  },
  calendar: {
    addMeetings: 'Add meeting',
    allSayEvent: 'Full-day event',
    areYouSureToRemoveMeeting: 'Are you sure you want to delete this meeting?',
    commencement: 'Start',
    completion: 'Completion',
    deletedMeeting: 'Deleted meeting',
    editMeeting: 'Edit meetings',
    endTime: 'Closing time',
    meeting: 'meeting | meetings',
    meetingModifyError: 'Meeting modification failed. Try again.',
    meetingsOn: 'Meetings on the day',
    planMeeting: 'Plan a meeting',
    removeMeetingError: 'Deleting the meeting failed. Try again.',
    savedMeeting: 'The meeting was recorded',
    selectedMeetingHasBeenRemove: 'The selected meeting has been removed',
    selectedMeetingWasRecorded: 'The selected meeting was recorded',
    showToday: 'Show today',
    startTime: 'Start time'
  },
  client: {
    addClient: 'Add client',
    client: 'Client',
    clientAvatar: 'Client avatar',
    clients: 'Clients',
    fullClientsList: 'Full list of clients'
  },
  communication: {
    messageEmail: 'E-mail messages',
    messageSMS: 'SMS messages'
  },
  communicationMail: {
    emailSend: {
      emailHasBeenSend: 'The email was sent',
      emailSendError: 'Sending an e-mail message has failed. Please try again.',
      emailSendSuccess: 'Email sent'
    },
    selectRecipients: 'Select recipients',
    sendEmailToCustomer: 'An email has been sent to clients.',
    sendTestMail: 'Send a test email',
    subject: 'Subject'
  },
  communicationSms: {
    customersChoose: {
      choose: 'Selected',
      customers: 'clients'
    },
    deselectAll: 'Deselect all',
    messageSend: 'Send Message',
    messageSendTo: {
      messageSendToCustomer: 'An SMS message was sent to clients.',
      messageSendToCustomerError: 'Sending a message has failed. Try again.'
    },
    messageSmsSendTo: {
      messageSmsSendToCustomer: 'SMS message was sent',
      messageSmsSendToCustomerError: 'Sending an SMS message has failed. Please try again.',
      messageSuccessSend: 'SMS message has been sent'
    },
    recipients: 'Recipients',
    sendForAll: 'Send to everyone',
    sendTestSms: 'Send a test SMS',
    sendTestSmsText: 'Message<span class="hidden-mobile-tiny">, that you want to send</span>'
  },
  credit: {
    bankEmployee: 'Bank employee',
    creditAdvisor: 'Credit advisor',
    creditExpert: 'Credit expert',
    insuranceAgent: 'Insurance agent'
  },
  customer: {
    backToCustomerList: 'Back to client list',
    customerAccountNotActive: 'The client account is not active. Inactive clients cannot be sent messages.',
    customerCreditOffers: 'Credit offers',
    customerNumber: 'Client number',
    incorrectStatus: 'Incorrect status',
    sendInvitation: 'Send an invitation'
  },
  customerAgreementsForm: {
    consent: {
      accept: 'I accept',
      and: 'and',
      contactWithExpert: 'Consent to expert contact',
      marketing: 'Marketing consent',
      privacyPolicy: 'privacy policy',
      privacyPolicyTitle: 'Privacy Policy',
      terms: 'regulations',
      termsAndPrivacy: 'Agree to the terms of the regulations and privacy policy',
      termsTitle: 'Regulations'
    },
    informationSendEmail: {
      offers: 'I want to receive by email information about offers, promotions, services or financial products directly from experts whose business cards are available on the site',
      serwis: 'I want to receive by e-mail information related to the opportunities offered by the service'
    },
    marketingConsentCustomers: 'Client marketing consents',
    updateProfileError: 'Data update failed. Try again.',
    yourProfileHasBeenUpdate: 'Your profile has been updated'
  },
  customerForm: {
    customerAdded: 'Added client',
    customerData: 'Client data',
    myData: 'My data',
    newCustomerAdded: 'A new client has been enrolled',
    newCustomerAddedError: 'Adding a new client has failed. Please try again.'
  },
  customerFormWrapper: {
    addNewCustomer: 'Add a new client',
    editCustomer: 'Edit client'
  },
  customerSettings: {
    deleteCustomer: 'Remove client',
    marketingConsents: 'Marketing consents'
  },
  customersList: {
    areYouSureSendAnInvitation: 'Are you sure you want to send an invitation?',
    deleteAccountCustomer: 'Deleted client account',
    deleteAccountCustomerError: 'Deleting a client account failed. Please try again.',
    deleteAccountCustomersError: 'Removal of clients has failed. Please try again.',
    deletedCustomers: 'Deleted clients',
    deleteSelectAccountCustomer: 'The selected client account has been deleted',
    deleteSelectCustomers: 'Remove selected clients',
    doYouWantDeleteAccountCustomer: 'Are you sure you want to delete this client\'s account?',
    doYouWantDeleteAccountCustomers: 'Are you sure you want to remove selected clients?',
    invitationSentToCustomer: 'The invitation was sent to the client.',
    inviteCustomer: 'The client was invited',
    lastInteraction: 'Last interaction',
    lastLogin: 'Last login',
    selectedCustomersHaveBeenRemoved: 'Selected clients have been removed',
    sendInvitationError: 'Sending an invitation to a client has failed. Please try again.'
  },
  customerStatuses: {
    draft: 'Draft',
    invitationConfirmed: 'Invitation confirmed',
    invited: 'Invited'
  },
  dashboard: {
    acceptedClients: 'Accepted clients',
    activeCreditsOffers: 'Active credit offers',
    allCustomers: 'All clients',
    cancelledOffers: 'Cancelled offers',
    checkTheProfile: 'Check out the profile',
    completedOffers: 'Completed offers',
    cookieSettings: 'Cookie settings',
    createOffer: 'Create an offer',
    createQuestion: 'Create a query',
    creditsOffers: 'Offers<span class="hidden-mobile-small"> credit</span>',
    currentCustomersServed: 'Current clients served',
    customersAcquired: 'Clients acquired',
    fullOffersList: 'Full list of offers',
    inviteClients: 'Invited clients',
    lastSevenDays: 'Last 7 days',
    lastThirtyDays: 'Last 30 days',
    myMessage: 'My Messages',
    myOffers: 'My offers',
    mySettings: 'My settings',
    newOffer: 'New offer',
    newOffers: 'New offers',
    offeringsRequiringInteraction: 'Offerings that require interaction',
    orderConsultation: 'Request a consultation',
    pendingTasksCreditsOffers: 'Pending assignments - Credit offers',
    pendingTasksCustomer: 'Pending tasks - Clients',
    requiredInteractions: 'Required interactions',
    sendOffers: 'offers sent',
    uncompletedOffers: 'Uncompleted offers',
    waitingMessage: 'Pending news',
    waitOffers: 'Waiting for an offer',
    welcomeToPanel: 'Welcome to the client panel!'
  },
  daysOfWeek: {
    friday: 'Friday',
    fridayShort: 'F',
    monday: 'Monday',
    mondayShort: 'M',
    saturday: 'Saturday',
    saturdayShort: 'S',
    sunday: 'Sunday',
    sundayShort: 'U',
    thursday: 'Thursday',
    thursdayShort: 'R',
    tuesday: 'Tuesday',
    tuesdayShort: 'T',
    wednesday: 'Wednesday',
    wednesdayShort: 'W'
  },
  forgotPassword: {
    errorAuth: 'Authorization error. Try again',
    recoverPassword: 'Recover password',
    resetPassword: 'Reset password'
  },
  general: {
    finhub: 'FinHub',
    finhubLogo: 'FinHub logo',
    finPl: 'FinPl',
    finPlLogo: 'logo FinPl'
  },
  inquiriesList: {
    afterModificationDate: 'After the modification date',
    areYouSureDeleteOffer: 'Are you sure you want to remove this offer?',
    areYouSureDeleteOffers: 'Are you sure you want to remove the selected listings?',
    created: 'Created',
    deleteOffer: 'Offer removed',
    deleteOfferError: 'Deleting the offer failed. Please try again.',
    deleteOffers: 'Deleted offers',
    deleteOffersError: 'Deletion of bids has failed. Please try again.',
    deleteSelectOffers: 'Remove selected offers',
    fillingOutTheForm: 'Filling out the form',
    lastContact: 'Last contact',
    selectOfferDelete: 'The selected bid has been removed',
    selectOffersDelete: 'Selected bids have been removed'
  },
  inquiry: {
    addingCreditOffer: 'Adding a credit offer',
    assignedCustomer: 'Assigned client',
    assignedTo: 'assigned to',
    backToOffersList: 'Return to list of offers',
    complaints: 'Complaints',
    creditOffer: 'Credit offer',
    deleteOffer: 'Remove offer',
    deleteQuestion: 'Delete query',
    duplicateOffer: 'Duplicate offer',
    duplicateQuestion: 'Duplicate query',
    editOffer: 'Edit Offer',
    editQuestion: 'Edit query',
    formOffer: 'Offer form',
    giveARating: 'Give a rating',
    inquiryForCounter: '1 inquiry | {n} inquiries',
    inquiryImage: 'Inquiry image',
    newCreditOffer: 'New credit offer',
    newQuestionOffer: 'New inquiry',
    offerQuestion: 'Request for Proposal',
    opinion: 'Opinions',
    saveOffer: 'Save Offer',
    saveQuestion: 'Save your inquiry',
    theFormCompletedBy: 'The form completed by',
    titleMobile: 'Offer'
  },
  inquiryAssignedCustomer: {
    deleteChoose: 'Remove selection',
    searchCustomer: 'Search for a client',
    selectedAccountCustomerNoExits: 'The account of the selected client no longer exists. We recommend deleting the listing.<br> You can duplicate this offer and assign another client to it.',
    selectedCustomer: 'Selected client',
    selectExistingProfile: 'Select an existing profile',
    youCantChangeStatusOffer: 'Note: You cannot change the status of the offer and send messages until the client approves the invitation.'
  },
  inquiryBankOffer: {
    allBanksOnList: 'I want to know the best deals from&nbsp;among all the banks that FinHub works with.',
    doYouWantNowOffersBanks: 'Do you want to know the offers of specific banks?',
    onlyMyOwnChoose: 'I want to know the best offers only from banks that I will choose myself.',
    preferredBanksOffer: 'Banks preferred offering',
    selectAll: '',
    selectedBanks: 'Selected banks'
  },
  inquiryComplaints: {
    areYouSureYouWantToArchiveClaim: 'Are you sure you want to archive the claim?',
    complaintArchived: 'Complaint archived',
    complaintArchivedError: 'Archiving of the claim has failed. Try again.',
    complaintHasBeenArchived: 'Messages in the complaints thread have been archived',
    complaintProcess: 'If your cooperation with an expert has not worked out, you can start the complaint process. Click the button below to open a chat with the service administrator',
    makeComplaint: 'I make a complaint',
    sendComplaint: 'A claim has been sent',
    sendComplaintError: 'Sending a message failed. Try again.',
    yourComplaint: 'Your complaint',
    yourComplaintHasBeenSend: 'The message in the complaint thread has been sent'
  },
  inquiryContactInfo: {
    chooseHours: 'Select a time',
    contactInformation: 'Contact information',
    preferredContactHours: 'Preferred contact hours'
  },
  inquiryFiles: {
    areYouSureSelectedFileRemove: 'Are you sure you want to delete the selected file?',
    downloadFileError: 'An error occurred while downloading the file',
    filesAttached: 'Attached are the files',
    filesAttachedError: 'File attachment failed. Try again.',
    filesHasBeenAttached: 'The files were attached to the offer',
    filesHasBeenUpdated: 'The selected file has been updated',
    filesUpdated: 'File updated',
    filesUpdatedError: 'The file update failed. Try again.',
    noFileForOffer: 'No files attached to the offer',
    removeFile: 'Deleted file',
    removeFileError: 'Deleting the file failed. Try again.',
    selectedFileRemove: 'The selected file has been deleted',
    youCanAddFileAfterSave: 'Files can be added after saving the offer.'
  },
  inquiryFinancialInfo: {
    addFinancialCommitment: 'Add financial commitment',
    addSourceIncome: 'Add a source of income',
    addSourceOfIncome: 'Add source of income',
    amountOfIncome: 'Amount of income',
    amountOfIncomeCurrentYear: 'The amount of income for the current year',
    amountOfIncomePreviousYear: 'The amount of income for the previous year',
    amountOfRevenueCurrentYear: 'The amount of revenue for the current year',
    amountOfRevenuePreviousYear: 'The amount of income for the previous year',
    areYouSureYouWantToRemoveCommitment: 'Are you sure you want to remove this commitment?',
    areYouSureYouWantToRemoveSourceIncome: 'Are you sure you want to remove this source of income?',
    bankSalaryReceived: 'The bank where the salary is received',
    commitmentHasBeenRemove: 'The commitment has been removed',
    contractType: 'Type of contract',
    currencyOfIncome: 'Currency of income',
    deleteCommitment: 'Remove the commitment',
    DoYouHaveSourcesOfIncome: 'Do you have sources of income',
    editCommitment: 'Edit commitment',
    editSourceIncome: 'Edit source of income',
    financialData: 'Financial data',
    financialLiabilities: 'Financial liabilities',
    firstAddFinancialCommitment: 'First, add a source of income',
    formOfContact: 'Form of contract',
    forRepayment: 'To be repaid',
    income: 'Income',
    incomeThisYear: 'Income this year',
    industry: 'Industry',
    installmentAmount: 'Installment amount',
    nameOfCurrency: 'Currency name',
    nameTypeOfIncome: 'Name of type of income',
    numberBillingMonthsCurrentYear: 'Number of billing months in the current year',
    offerMustBeRecorded: 'Be sure to save the offer to make this change permanent',
    revenueThisYear: 'Revenue this year',
    settlementMethod: 'Method of settlement',
    sourceIncomeHasBeenRemove: 'Source of income has been removed',
    taxRate: 'Tax rate',
    typeOfIncome: 'Type of income',
    youCanAddOnlyToSourceIncome: 'Financial liabilities can only be added to sources of income that are business activities'
  },
  inquiryForm: {
    basicInfo: 'Basic information',
    chooseTheCustomer: 'Before editing the quotation form, select the client.',
    formSaved: 'The form has been saved',
    householdInfo: 'Household',
    modifyFormError: 'Modification of the form failed. Please try again.',
    modifyOfferError: 'Bid modification failed. Please try again',
    offerHasBeenSave: 'The selected bid was recorded',
    queryHasBeenSaved: 'The selected query has been saved',
    queryModifyError: 'Modification of the query failed. Try again.',
    querySaved: 'A query has been saved',
    saveOffer: 'The offer was recorded',
    thankYouForFillingForm: 'Thank you for filling out the form. We are currently looking for the best expert for you.'
  },
  inquiryHouseholdInfo: {
    additionalInfo: 'Additional information',
    ageOfOldestBorrower: 'Age of the oldest borrower',
    numberOfPeopleOnHousehold: 'Number of people in the household'
  },
  inquiryLiabilitiesInfo: {
    addCommitment: 'Add commitment',
    amountRepaid: 'Amount to be repaid',
    currencyAmountRepaid: 'Currency of the amount to be repaid',
    currencyOfCommitment: 'Currency of obligation',
    doYouHaveFinancialLiabilities: 'Do you have financial obligations',
    editCommitment: 'Edit commitment',
    nameOfCurrencyAmountRepaid: 'Name of the currency of the amount to be repaid',
    nameOfCurrencyOfCommitment: 'Name of the liability currency',
    newCommitment: 'New commitment',
    sendOpinion: 'Sent feedback',
    sendOpinionError: 'Sending feedback failed. Please try again.',
    sourceIncome: 'Source of income',
    typeOfCommitment: 'Type of commitment',
    yourExpertAssessment: 'Your expert assessment',
    yourOpinionWasSend: 'Your feedback has been sent.<br>Thank you!'
  },
  inquiryOfferForm: {
    backToComparingOffer: 'Return<span class="hidden-mobile-tiny"> to offer comparison</span>',
    bridgeInsurance: 'Bridge insurance',
    commission: 'Commission',
    earlyRepayment: 'Early repayment',
    estatesInsurance: 'Estates Insurance',
    formOfferForCustomer: 'Client quotation form',
    interestRate: 'Interest rate',
    interestRateFixed: 'Fixed interest rate',
    lifeInsurance: 'Life insurance',
    margin: 'Margin',
    noSelectedBankForOffer: 'Banks were not selected to bid',
    offerEdit: 'Edit offer',
    offerHaveVariant: 'The offer has variants',
    offerSaveError: 'The offer label record failed.',
    pricing: 'Valuation',
    recalculate: 'Recalculate',
    selectCustomer: 'Client selection',
    selectOfferForCustomer: 'Choose the offer and variants for the client',
    wibor: 'WIBOR',
    workInsurance: 'Work insurance'
  },
  inquiryOfferLoanSimulation: {
    capital: 'Capital',
    creditAmount: 'Credit amount',
    creditCondition: 'Credit status',
    creditTermsAndConditions: 'Credit terms and conditions',
    installmentPlan: 'Installment plan',
    interest: 'Interest',
    methodOfRepayment: 'Method of repayment',
    monthInstallment: 'Monthly installment',
    numberInstallment: 'Installment No.',
    numberOfInstallments: 'Number of installments',
    rateInterest: 'Interest rate',
    ratesInstallmentsSimulation: 'Simulation of offer installments at interest rates',
    repaymentPeriod: 'Repayment period'
  },
  inquiryOffers: {
    addOffer: 'Add offer',
    addTheFirstOffer: 'You have not prepared any offer yet. Add your first offer.',
    areYouSureToSendMessage: 'Are you sure you want to send a notification?',
    bridgingInsurance: 'Bridging insurance',
    earlyOverpaymentValue: 'Previous overpayment',
    earlyRepaymentValue: 'Early repayment',
    finishing: 'Finishing',
    fixedLendingRate: 'Fixed interest rate',
    fixedLoanInstallment: 'Installment op-rate fixed',
    lendingRateValue: 'Variable interest rate',
    lifeInsuranceValue: 'Life insurance',
    loanInstallmentValue: 'Installment variable interest rate',
    messageSendError: 'Sending a message has failed. Try again.',
    messageSendSuccess: 'The message has been sent',
    messageSendSuccessAboutOffers: 'A message was sent to the client about the prepared offers',
    noOffersHaveYet: 'No offers have yet been prepared.',
    notifyCustomerAboutOffer: 'Notify the client of the offer',
    ownContribution: 'Own contribution',
    propertyInsuranceValue: 'Property insurance',
    propertyPrice: 'Property price',
    sendMessageChangeStatus: 'Sending the notification will change the bid status to "Sent"',
    simulationInstallmentFixed: 'Installment simulation - fixed rate',
    simulationInstallmentVariable: 'Simulation of installments - variable rate',
    valuation: 'Property valuation',
    workInsuranceValue: 'Unemployment insurance'
  },
  inquiryOffersCart: {
    offerNotYetAdded: 'No offer has been added yet',
    offerVariant: 'offer variant',
    selectedOffers: 'Selected offers'
  },
  inquirySingleOffer: {
    addedToOffer: 'Added to offer',
    addToOffer: 'Add<span class="hidden-mobile"> to offer</span>',
    cannotBeCombinedWithSelectedOffer: 'cannot be combined with the selected offer',
    deleteFromOffer: 'Remove<span class="hidden-mobile"> from offer</span>',
    excluded: 'Excluded',
    hideDetailsOffer: 'Hide<span class="hidden-mobile"> offer</span> details',
    showDetailsOffer: 'Show<span class="hidden-mobile"> offer</span> details'
  },
  inquiryStatusSelect: {
    areYouSureYouWantToChangeTheStatusOfTheOffer: 'Are you sure you want to change the status of the offer?',
    modifyStatusError: 'Status modification failed. Try again.',
    orderStatus: 'Order status',
    savedStatus: 'The status has been recorded',
    StatusHasBeenSaved: 'The selected status has been saved'
  },
  inquiryTransactionType: {
    amountForFinishing: 'Amount for finishing',
    doYouNeedFundsForFinishing: 'Do you need funds for finishing',
    expectedLoanInstallment: 'Expected loan installment',
    metric: 'Metric',
    purposeOfCredit: 'Purpose of the loan',
    subjectOfSecurity: 'Subject of security',
    valueOfProperty: 'Value of real estate',
    yourOwnContribution: 'Your own contribution will be'
  },
  installmentTypes: {
    diminish: 'Raty malejące',
    equal: 'Raty stałe'
  },
  invitationConfirm: {
    confirmInvite: 'Confirm invitation',
    invitationAccept: 'The invitation has been confirmed.',
    invitationConfirmation: 'Confirmation of invitation'
  },
  list: {
    fromLatest: 'From the latest',
    fromOldest: 'From the oldest',
    lastModify: 'Last Modification'
  },
  logging: {
    forgotPassword: 'Forgot your password?',
    logging: 'Log in',
    login: 'Log in',
    registrationEndYouCanLogIn: 'Registration completed successfully.<br>You can now log in..',
    yourAccountActiveNow: 'Your account has been activated.<br>You can log in now.',
    yourPasswordChangeLogIn: 'The password for your account has been changed.<br>You can log in now.'
  },
  message: {
    messageForCounter: '1 message | {n} messages',
    noMessage: 'No messages in the thread',
    read: 'Read',
    topic: {
      archiveTopicConfirmBtnTxt: 'Yes, archive',
      archiveTopicConfirmTitle: 'Are you sure you want to archive the thread?',
      archiveTopicErrorTxt: 'Thread archiving failed. Please try again.',
      archiveTopicSuccessTitle: 'Thread archived',
      archiveTopicSuccessTxt: 'Messages in the thread have been archived'
    }
  },
  messageForm: {
    addAttachment: 'Add attachment',
    attachedFiles: 'Attached files',
    backToMessagesList: 'Go back to the message list',
    deleteFile: 'Delete file',
    descriptionFile: 'File description',
    downloadFile: 'Download file',
    fileName: 'File name',
    messageWasSendInThread: 'The message was send in a thread',
    modifyFile: 'Modify file',
    myMessage: 'My message',
    noAssignedExpert: 'No expert assigned',
    numberOfCall: 'Conversation number',
    offerPreview: 'Offer preview',
    sendMessageError: 'Failed to send the message. Try again.',
    uploadFile: 'Upload file',
    writeTheMessage: 'Write a message'
  },
  messagesList: {
    afterLastDateMessage: 'After the date of the last message',
    archivedSelectedThreads: 'Selected threads have been archived',
    archivedThreads: 'Archived threads',
    archivedThreadsError: 'Archiving of threads failed. Try again.',
    archiveSelectThreads: 'Archive selected threads',
    areYouSureArchivedSelectedThreads: 'Are you sure you want to archive selected threads?',
    chooseCustomer: 'Select a client',
    chooseExpert: 'Choose an expert',
    chooseOffer: 'Select an offer',
    directMessage: 'Direct message',
    lastMessage: 'Last message',
    messageText: 'Message text',
    numberOfOffer: 'Offer no.',
    originMessage: 'Origin of the message',
    thisOfferHasBeenRemoved: 'This offer has been removed'
  },
  monthsName: {
    april: 'April',
    aprilShort: 'Apr.',
    august: 'August',
    augustShort: 'Au.',
    december: 'December',
    decemberShort: 'Dec.',
    february: 'February',
    februaryShort: 'Feb.',
    january: 'January',
    januaryShort: 'Jan.',
    july: 'July',
    julyShort: 'Jul.',
    june: 'June',
    juneShort: 'Jun.',
    march: 'March',
    marchShort: 'Mar.',
    may: 'May',
    mayShort: 'May',
    november: 'November',
    novemberShort: 'Nov.',
    october: 'October',
    octoberShort: 'Oct.',
    september: 'September',
    septemberShort: 'Sept.'
  },
  notesList: {
    addNotes: 'Add a note',
    areYouSureDeleteSelectNote: 'Are you sure you want to delete this note?',
    contentOfNote: 'Note content',
    createDate: 'Creation date',
    deleteNote: 'Note deleted',
    deleteNoteError: 'Note deletion failed. Try again.',
    deleteSelectNote: 'The selected note has been deleted',
    editNotes: 'Editing a note',
    lastModifyDate: 'Date last modified',
    modifyNoteError: 'Modification of the note failed. Try again.',
    newNotes: 'New note',
    note: 'Note',
    noteForClient: 'Note to client',
    noteSaved: 'A note was written',
    selectedNoteWasRecorded: 'The selected note has been saved'
  },
  opinion: {
    newOpinions: 'Latest opinions',
    opinionByCustomer: 'Opinion added by client',
    opinionForCounter: '1 opinion | {n} opinions',
    opinionViolates: 'If any opinion violates your image or you disagree with its content, please contact us immediately.',
    userImgThumbnail: 'User image thumbnail',
    yourOpinion: 'Your feedback'
  },
  pageLinks: {
    collaboration: 'Collaboration',
    compareCreditOffers: 'Compare credit offers',
    contact: 'Contact',
    findTheBestExpert: 'Find the best expert',
    howThisWorks: 'How this works',
    tutorials: 'Tutorials'
  },
  pageNotFound: {
    backToDashboard: 'Go back to dashboard',
    pageNotFound: 'Page was not found'
  },
  pagination: {
    advisors: 'advisors',
    articles: 'articles',
    buttonNext: 'Next',
    buttonPrev: 'Prev',
    customers: 'klientów',
    elements: 'element',
    inquiries: 'inquiries',
    messages: 'messages',
    outOf: 'out of'
  },
  promotions: {
    amIWinning: 'Am I winning',
    amount: 'Amount',
    beginPromotionAuction: 'Begin the promotion auction',
    bidOnPromotion: 'Bid on the promotion',
    bidPromotion: 'Bid on the promotion',
    costOfPromotion: 'Cost of promotion',
    endsAt: 'Promotion occupied until',
    highestBid: 'Highest bid',
    name: 'Name',
    outbidPromotion: 'Outbid',
    pay: 'Pay',
    paymentInformation: 'Payment information',
    placeABid: 'Place an offer',
    placeBidErrorText: 'Placing a bid in the auction failed. Please try again.',
    placeBidSuccessText: 'Your bid in the selected promotion auction has been placed.',
    placeBidSuccessTitle: 'Placing a bid in the auction',
    proceedToPayment: 'Proceed to payment',
    profilePlacement: 'Profile placement',
    promotions: 'Promotions',
    promotionTooltipInfo: 'If you would like your profile to be visited more often, please reserve a promotional space. The reservation of a promotional space is done in auction mode. Set the amount you can pay to promote your profile. If no one outbids you within 24 hours, your profile will appear in the selected slot.',
    seeWhereYourProfileWillAppear: ' SEE WHERE YOUR PROFILE WILL APPEAR.',
    status: {
      auction: 'Auction in progress',
      free: 'Free',
      occupied: 'Occupied'
    }
  },
  register: {
    acceptTermsTxt: '<span>I accept <a title="The terms and conditions" href="{regulationsUrl}" target="_blank" rel="nofollow noopener noreferrer" class="text-medium-light">the terms and conditions</a> as well as <a title="The privacy policy" href="{privacyPolictUrl}" target="_blank" rel="nofollow noopener noreferrer" class="text-medium-light">the privacy policy</a>.</span>',
    accountActivated: 'Account activation',
    contactAdviserAgreementTxt: 'I would like to receive information about offers, promotions, services, or financial products via email directly from the experts whose profiles are available on the website ',
    contactFinhubAgreementTxt: 'I would like to receive email updates regarding the possibilities and features offered by the website ',
    dataProcessingAgreementTxt: '<span>Personal data provided in the form is processed by FINHUB Sp. z o.o. for the purpose of providing services electronically in accordance with <a title="The terms and conditions" href="{regulationsUrl}" target="_blank" rel="nofollow noopener noreferrer" class="text-medium-light">the terms and conditions</a>, for archival purposes, and for purposes corresponding to the content of additionally selected consents.</span><br><span>If you consent to receiving information directly from experts, it applies globally, which means that any of the experts cooperating with FINHUB may send you messages.</span><br><span>Details: <a title="Privacy policy" href="{privacyPolicyUrl}" target="_blank" rel="nofollow noopener noreferrer" class="text-medium-light">privacy policy</a>.</span>',
    register: 'Register',
    registration: 'Registration',
    registrationError: 'Registration error. Please try again.',
    registrationExpert: 'Expert Registration'
  },
  registerMailSent: {
    sendMessage: 'Message sent',
    sendMessageToEmail: 'An email was sent to the email address you provided with instructions on how to complete your account registration.'
  },
  resetPassword: {
    linkPasswordIncorrect: 'The generated password reset link is incorrect.',
    resetPass: 'Resetting the password',
    yourEmail: 'Your e-mail address',
    yourNewPassword: 'Your new password',
    yourPassword: 'Your password'
  },
  settlements: {
    allPricesAreNet: 'All prices provided are net prices.',
    amount: 'Amount',
    changeYourPackage: 'Change your package',
    currentSubscription: 'Current subscription',
    date: 'Date',
    download: 'Download',
    expiresInDays: 'expires in {daysAmount} days',
    expiresOn: 'Expires on',
    extendThisPackageBy: 'Extend this package for {timeTxt}',
    extendYourPackageBy: 'Extend your package by {timeTxt}',
    grossPrice: 'Gross price',
    inactiveAccount: 'Your account is inactive',
    invoice: 'Invoice',
    packageChange: 'Package change',
    packages: 'Packages',
    paymentHistory: 'Payment history',
    percentOff: '{percentAmount}% off',
    plnPerMonth: 'PLN / month',
    probationaryPeriod: {
      probationaryPeriodMessage: 'The trial period is underway. Until the end of the trial period, there is',
      probationaryPeriodTime: 'days'
    },
    purchaseBasicConfirmText: 'Do you confirm changing the plan to {packageName}?<br>This is a free plan that offers the least features.',
    purchaseBasicPackageErrorText: 'Package change failed.<br>Please try again.',
    purchasePlanErrorText: 'Generating payment link failed.',
    purchasePlanSuccessText: 'After clicking "OK", you will be redirected to the payment page.',
    purchasePlanSuccessTitle: 'Proceed to payment',
    sectionAvailableForActiveUsers: 'This section is available only for users with active account.',
    selectPlan: 'Subscribe to one of our plans',
    subscriptionWalidIndefinitely: 'The subscription is valid indefinitely.',
    type: 'Type',
    yourCurrentPackage: 'Your current package',
    yourCurrentPackageIs: 'Your current package is {packageName}',
    yourPlan: 'Your plan'
  },
  statuses: {
    accepted: 'Accepted',
    rejected: 'Rejected',
    toAccept: 'To accept'
  },
  time: {
    hoursShort: '{n} hrs',
    hoursShortAgo: '{n} hrs ago',
    minutesShort: '{n} min.',
    minutesShortAgo: '{n} min. ago',
    now: 'now',
    timeElapsedDay: '1 day | {n} days',
    timeElapsedDayAgo: '1 day ago | {n} days ago',
    timeElapsedMonth: '1 month | {n} months',
    timeElapsedMonthAgo: '1 month ago | {n} months ago',
    timeElapsedYear: '1 year | {n} years',
    timeElapsedYearAgo: '1 year ago | {n} years ago',
    today: 'Today'
  },
  ui: {
    action: 'Action',
    add: 'Add',
    added: 'Added',
    archive: 'Archive',
    assessment: 'Assessment',
    backToGeneralPage: 'Back to general page',
    backToLoginPage: 'Back to login page',
    bank: 'Bank',
    calendar: 'Calendar',
    cancel: 'Cancel',
    chooseBank: 'Choose a bank',
    chooseCurrency: 'Select a currency',
    chooseDate: 'Choose date',
    chooseIndustry: 'Choose industry',
    chooseYourSourceOfIncome: 'Choose your source of income',
    close: 'Close',
    comments: 'Comments',
    content: 'Content',
    dataLoadError: {
      dataErrorMess: 'Data loading failed.',
      forTryAgain: 'to try again.',
      resetPageButton: 'Refresh the page'
    },
    edit: 'Edit',
    errorOccurred: 'An error occurred',
    errorOccurredTryAgain: 'An error has occurred. Please try again.',
    featured: 'Featured',
    form: 'Form',
    from: 'from',
    goToLoginPage: 'Got to login page',
    invite: 'Invite',
    loadingDataInProgress: 'Loading data in progress',
    logout: 'Logout',
    massCommunication: 'Mass communication',
    massCommunicationTitleMobile: 'Communication',
    menu: 'Menu',
    messages: 'Messages',
    myArticles: 'My articles',
    needsInteraction: 'that require interaction',
    next: 'Next',
    nip: 'NIP',
    no: 'No',
    none: 'None',
    noResultsForGivenPhrase: 'No results for the given phrase',
    notes: 'Notes',
    notNow: 'Not&nbsp;now',
    nr: 'no.',
    offers: 'Offers',
    open: 'Open',
    or: 'or',
    pulpit: 'Desktop',
    recentActivity: 'Recent activity',
    refresh: 'Refresh',
    remove: 'Remove',
    save: 'Save',
    saveChange: 'Save change',
    savedChanges: 'Changes saved',
    saveSetting: 'Save your settings',
    search: 'Search',
    seeAll: 'See all',
    send: 'Send',
    sendAssessment: 'Send Assessment',
    settings: 'Settings',
    settlements: 'Settlements',
    source: 'Source',
    thisOperationCannotUndone: 'This operation cannot be undone',
    tin: 'TIN',
    title: 'Title',
    to: 'to',
    tryAgain: 'Try Again',
    unread: 'unread',
    variant: 'Variant',
    website: 'Website',
    years: 'years',
    yes: 'Yes',
    yesChange: 'Yes, change',
    yesIAgree: 'Yes, I agree',
    yesInvite: 'Yes, invite',
    yesRemove: 'Yes, remove',
    yesSend: 'Yes, send',
    youHave: 'You have'
  },
  user: {
    additionalSpecializations: 'Additional specializations',
    address: 'Address',
    association: 'Association',
    changePassword: 'Change password',
    choose: 'Select',
    city: 'City',
    county: 'County',
    currentPackageDoesNotIncludeAccessToSection: 'Your current package does not include access to this section.',
    distance: 'Distance',
    emailAddress: 'Email Address',
    firstName: 'First Name',
    fullName: 'Full Name',
    functionUnavailableInCurrentPackage: 'Function unavailable in the current package.',
    lastName: 'Last Name',
    myAccount: 'My account',
    other: 'Other',
    otherAssociation: 'Other association',
    password: 'Password',
    phone: 'Phone',
    phoneNumber: 'Phone Number',
    postalCode: 'Postal Code',
    province: 'Province/Region',
    region: 'Region',
    repeatPassword: 'Repeat password',
    savePassword: 'Save password',
    selectAssociation: 'Select association',
    selectCounty: 'Select county',
    selectOrder: 'Select order',
    selectProvince: 'Select Province/Region',
    selectRegion: 'Select region',
    selectSpecialization: 'Select specialization',
    selectSpecializations: 'Select specializations',
    selectStatus: 'Select status',
    specialization: 'Specialization',
    status: 'Status',
    taxIdentificationNumber: 'Tax Identification Number (NIP)',
    taxIdentificationNumberGB: 'Tax Identification Number',
    userAvatar: 'User avatar'
  },
  UserSettingsPasswordChange: {
    areYouSureToChangePassword: 'Are you sure you want to change your password?',
    newPassword: 'New password',
    passwordChange: 'Password change',
    passwordChangeError: 'Password change failed. Please try again.',
    passwordHasBeenChange: 'Your account password has been changed',
    passwordSave: 'Password saved'
  },
  validation: {
    date: 'Date is required',
    dateRange: 'Date range is required',
    email: 'This field must contain a valid email address',
    isChecked: 'This field must be checked to proceed',
    maxCharacters: 'This field can contain at most one character | This field can contain at most {n} characters',
    maxValue: 'The value cannot be greater than {n}',
    minCharacters: 'This field must contain at least one character | This field must contain at least {n} characters',
    minValue: 'The value cannot be less than {n}',
    onlyNumbers: 'This field must contain a number',
    passwordsDontMatch: 'Passwords do not match',
    phone: 'This field can start with a \"+\" sign and contain digits and spaces',
    required: 'This field is required',
    tin: 'TIN is made up of 2 letters, 6 numbers, and a final letter.',
    url: 'This field must contain a valid URL',
    zipCode: 'This field must have the format \"00-000\"',
    zipCodeGB: 'This field must contain valid UK postcode'
  }
};
